import React, { useRef, useState, useEffect, Fragment } from "react";
import {Form, Button, Spinner, Row, Col} from 'react-bootstrap';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { cargarArchivoFormSchema } from "../../common/validation-schemas";
import { cargarArchivoAction } from '../../store/actions/carga-masiva-action';
import { cargasPreviasAction } from '../../store/actions/carga-masiva-action';
import { serviceGetProveedores } from '../../api/carga-masiva-client';
import { Auth, LoadingComponent } from 'recupero-comunes';

const CargarArchivo = () => {

    const { rutUsuario, rutOrganizacion, paisOrganizacion } = Auth.currentUser();
    const user = { "rutUsrCreacion": rutUsuario, "idOrganizacion": rutOrganizacion, "codPais": paisOrganizacion, "modulo": 'cmar' };

    const fileRef = useRef();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    
    const [responsables, setResponsables] = useState([]);

    useEffect(() => {
        const obtenerProveedores = async () => {
            const roles = ['0070COBRAEX', '0070ABOEXT', '70PRSIPACIA'];
            setLoading(true);
            const listaProveedores = await fetchProveedoresByRoles(rutOrganizacion, roles);
            setLoading(false);
            setResponsables(listaProveedores); 
        };
        obtenerProveedores();
    }, []);
    const fetchProveedoresByRoles = async (rutOrganizacion, roles) => {
        const tipoPersona = '0080PROVE00';
        const resultados = [];

        for (const rol of roles) {
            const query = Buffer.from(JSON.stringify({
                idOrganizacion: rutOrganizacion,
                rol: rol,
                tipoPersona: tipoPersona
            })).toString('base64');

            try {
                const response = await serviceGetProveedores(query);
                if (Array.isArray(response)) {
                resultados.push(...response);
                }
            } catch (error) {
                console.error(`Error obteniendo proveedores para el rol ${rol}:`, error);
            }
        }
        return resultados;
    };

    // El hook useFormik (formik) permite definir las propiedades del formulario. Devuelve estados y funciones de ayuda.
    const formik = useFormik({
        
        initialValues: { file: null, responsable: '' }, // Valores iniciales para cada input del formulario
        validationSchema: cargarArchivoFormSchema, // Esquema de validación de Yup para el formulario.
        onSubmit: (values) => { // Función ejecutada al invocar formik.handleSubmit()
          

            // Iniciar 'Cargando...' en botón 'Cargar Archivo'
            setLoading(true);

            // Transformar archivo en Base64
            getBase64(values.file).then((base64data) => {
                
                // Data requerida para cargar archivo. Utilizamos sintaxis spread (...) para concatenar valores de user y datos de archivo. 
                
                let data = { ...user, responsable: values.responsable, "filename": values.file.name, "mimetype": values.file.type, "base64data": base64data };
                console.log('data > ', data);

                // Invocar a la acción que realiza la carga del archivo
                dispatch(cargarArchivoAction(data)).then(() => {

                    // Reseter el formulario
                    handleReset();

                    // Obtener las cargas previas.
                    let query = btoa(JSON.stringify({ "idOrganizacion": rutOrganizacion, "tipoCarga":"108010" }));
                    dispatch(cargasPreviasAction(query));

                }).catch((error) => {
                    setLoading(false);
                    console.error(error);
                    alert(error.message);
                });
            })
            .catch((error) => {
                setLoading(false);
                console.error(error);
                alert(error.message);
            });
        }
    });

    const handleReset = () => {
        fileRef.current.value = "";
        formik.resetForm();
        setLoading(false);
    }

    return (
        <Fragment>
        <LoadingComponent show={loading}/>
        <div>
            <Form noValidate onSubmit={formik.handleSubmit} className="mt-4">
                <Row className="mb-3">
                    <Col md={8}>
                        <Form.Group controlId="formFile" className="mb-3">
                            <Form.Label><b>Archivo</b></Form.Label>
                            <Form.Control ref={fileRef} type="file" name="file"
                                onChange={event => { formik.setFieldValue("file", event.currentTarget.files[0]); }} onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.file}
                                isValid={formik.touched.file && !formik.errors.file}
                            />
                            <Form.Text className="text-muted">Tamaño máximo del archivo: 10MB</Form.Text>
                            <Form.Control.Feedback type="invalid"> {formik.errors.file} </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        <Form.Group controlId="responsable" className="mb-3">
                            <Form.Label><b>Reasignar Responsable</b></Form.Label>
                            <Form.Select
                                name="responsable"
                                value={formik.values.responsable}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.responsable}
                            >
                                <option value="">Seleccione...</option>
                                {responsables.map(res => (
                                    <option key={res.id} value={res.id}>{res.nombre}</option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                {formik.errors.responsable}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Col>
                </Row>             

                <hr className="mt-4" />

                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <Button className="me-md-2" variant="warning" type="button" onClick={() => { handleReset() }}>Limpiar</Button>
                    <Button variant="danger" type="submit" disabled={loading}>
                        { loading ?
                        <div><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Cargando...</div>
                        : "Cargar Archivo" }
                    </Button>
                </div>

            </Form>
        </div>
        </Fragment>
    )
}

export default CargarArchivo;

const getBase64 = (file) => {
    return new Promise(resolve => {
        let reader = new FileReader();
        // Convert the file to base64 text
        reader.readAsDataURL(file);
        reader.onload = () => {
            resolve(reader.result);
        };
    });
};